import { Injectable, Inject, Injector } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IUser } from "src/app/shared/model/user-interface";
import { IAppConfig } from "../Config/app-config.model";
import { UserModel } from '../user/UserModel';
import { UserRegistrationService } from "../user-registration/user-registration.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private userProfileBehaviorSubject: BehaviorSubject<IUser> =
    new BehaviorSubject<IUser>({} as IUser);
  public internalToken: string;

  constructor(
    private httpParameter: HttpClient,
    @Inject("appconfig") private configParam: IAppConfig,
    private userRegistrationService: UserRegistrationService,
    public _injector: Injector
  ) {}

  LoginAnonymous() {
    const userModel = new UserModel();
    userModel.ApiToken = 'anonymous' + this.configParam.ApiConfig.PUBLIC_COMMENT_APP_TOKEN;;
    userModel.UserName = 'anonymous' + this.configParam.ApiConfig.PUBLIC_COMMENT_APP_TOKEN;;
    userModel.Role = 'Public User';

    this.RedirectToDemo(userModel);
  }

  RedirectToDemo(userModel: UserModel) {
    this.userRegistrationService.GetRedirectionUrl(userModel).subscribe(resp => {
      if (this.LocationsInHeader(resp) && this.UserProfileUndefinedOrNull()) {
        let splt = resp.headers.Location.split("internaltoken=")
        this.internalToken = splt[1];
        this.userRegistrationService.GetUserRole(this.internalToken).subscribe(response => {
          this.AssignAndSetUserProfile(response);
        });
      }
    });
  }

  private AssignAndSetUserProfile(response: any) {
    var userProfile: IUser;
    if (response != null) {
      userProfile = this.assignUserProfile(response);
      if (userProfile.authToken) {
        this.setUserProfile(userProfile);
      }
    }
  }

  private UserProfileUndefinedOrNull(): boolean {
    return this.getUserProfile() === undefined || this.getUserProfile() === null;
  }

  private LocationsInHeader(resp: any): boolean {
    return resp && resp.headers && resp.headers.Location;
  }

  GetUserRole(token: string): Observable<any> {
    return this.httpParameter.get<any>(
      `${this.configParam.CoreConfig.USERROLE_API_ENDPOINT}/user?token=${token}`
    );
  }

  getUserProfile() {
    const userProfile = JSON.parse(
      window.sessionStorage.getItem(
        `eMonitor-${this.configParam.CoreConfig.Env}`
      )
    );
    return userProfile as IUser;
  }

  setUserProfile(userProfile: IUser) {
    window.sessionStorage.setItem(
      `eMonitor-${this.configParam.CoreConfig.Env}`,
      JSON.stringify(userProfile)
    );
  }

  publishUserProfile(data: any) {
    this.userProfileBehaviorSubject.next(data);
  }

  getObservableUserProfile(): Observable<any> {
    return this.userProfileBehaviorSubject.asObservable();
  }

  assignUserProfile(profile: IUser): IUser {
    if (profile !== undefined) {
      return {
        User: profile.User,
        Role: profile.Role,
        SessionToken: profile.SessionToken,
        authToken: profile.authToken,
        isAuthenticated: true,
      };
    }
    return {
      User: "UMoreno",
      Role: [],
      SessionToken: "",
      authToken: "",
      isAuthenticated: false,
    };
  }

  clearUserProfile(): void {
    window.sessionStorage.clear();
  }

  get isAdmin(): boolean {
    const userProfile = this.getUserProfile();

    if (userProfile !== undefined) {
      return userProfile.Role.map((x) => x.toLowerCase()).indexOf("admin") >= 0;
    }

    return false;
  }
}
